<template>
    <transition name="fade">
        <div 
            class="formfield__error">
            {{ error }}
        </div>
    </transition>
</template>

<script>

export default {
    props: {
        error: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            isVisible: false,
        };
    },
    methods: {
        showError() {
            this.isVisible = true;
        },
        hideError() {
            this.isVisible = false;
        },
    },
};
</script>
